import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Lock, User, Eye, EyeOff, Loader2 } from 'lucide-react';
import './Admin.css';

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(form.username, form.password);
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-logo">
          <Lock size={28} />
        </div>
        <h1 className="admin-login-title">Admin Login</h1>
        <p className="admin-login-sub">Knowledge Base Management</p>

        <form onSubmit={handleSubmit} className="admin-login-form">
          {error && <div className="admin-alert admin-alert--error">{error}</div>}

          <div className="admin-field">
            <label className="admin-label">Username</label>
            <div className="admin-input-wrap">
              <User size={15} className="admin-input-icon" />
              <input
                className="admin-input"
                type="text"
                placeholder="Enter username"
                value={form.username}
                onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
                required
                autoFocus
              />
            </div>
          </div>

          <div className="admin-field">
            <label className="admin-label">Password</label>
            <div className="admin-input-wrap">
              <Lock size={15} className="admin-input-icon" />
              <input
                className="admin-input"
                type={showPw ? 'text' : 'password'}
                placeholder="Enter password"
                value={form.password}
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                required
              />
              <button type="button" className="admin-input-toggle" onClick={() => setShowPw(s => !s)}>
                {showPw ? <EyeOff size={15} /> : <Eye size={15} />}
              </button>
            </div>
          </div>

          <button className="admin-btn admin-btn--primary admin-btn--full" type="submit" disabled={loading}>
            {loading ? <Loader2 size={16} className="admin-spin" /> : null}
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
